<template>
  <qx-card-form title="位置" v-show="showComponent" :defaultContentShow="false">
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px"></qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>
<script>
import {
  getAddressOptions,
} from '@qx/utils';
export default {
  data () {
    return {
      showComponent: false,
      baseForm: {
        isStateOptions: [],
        inline: true,
        form: [
          {
            label: '位置状态',
            value: 'isState',
            type: 'select',
            default: '-1',
          },
          {
            label: '起始位置',
            value: 'position',
            type: 'cascader',
            placeholder: ' ',
            fakeShow: true,
            default: [],
            options: getAddressOptions({
              showLevel: 1,
            }),
          },
        ],
      },
    };
  },
  methods: {
    async getDataTest () {
      this.sub();
    },
    setList (enums) {
      this.baseForm.isStateOptions = enums;
    },
    async handleSubData (cache) {
      let formData = null;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      let sourceInfo = {
        sourceProvince: '',
        sourceRegion: '',
        sourceCounty: '',
      };
      if (formData.position && formData.position.length) {
        sourceInfo = {
          sourceProvince: formData.position[0], // 省
          sourceRegion: formData.position[1], // 市
          sourceCounty: formData.position[2], // 区
        };
      }
      if (formData || cache) {
        if (this.showComponent) {
          formData = {
            ...formData,
            ...sourceInfo,
          };
        } else {
          formData = {};
        }
      }
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    async sub () {
      const formData = await this.handleSubData();
      if (formData) {
        delete formData.position;
      }
      console.log('位置信息提交参数', formData);
      return formData;
    },
    init (data = {}) {
      this.$refs.baseForm.reset();
      // 重置表单为初始状态
      this.resetBaseForm(data.vehicleClass);

      if (data.trailer) {
        data.isState = data.trailer.isState;
        data.sourceProvince = data.trailer.sourceProvince || '';
        data.sourceRegion = data.trailer.sourceRegion || '';
        data.sourceCounty = data.trailer.sourceCounty || '';
        if (data.trailer.sourceLocation) {
          const addressName = data.trailer.sourceLocation.replace(/·/g, '/');
          this.setFormAttrVal({
            form: this.baseForm,
            attr: 'placeholder',
            value: addressName || ' ',
            names: ['position'],
          });
        }
      }

      if (data.isState !== undefined) {
        data.isState = String(data.isState || -1);
      }
      if (data.sourceProvince) {
        data.position = [
          data.sourceProvince,
          data.sourceRegion,
          data.sourceCounty,
        ];
      } else {
        data.position = [];
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'placeholder',
          value: ' ',
          names: ['position'],
        });
      }
      this.$refs.baseForm.setVal(data);
    },
    // 设置所有表单
    resetBaseForm (vehicleClass) {
      if (vehicleClass === '1') {
        this.showComponent = true;
      }
      if (vehicleClass === '2') {
        this.showComponent = false;
      }
    },
    formChange (vehicleClass) {
      this.resetBaseForm(vehicleClass);
    },
    receivedData (vehicleClass) {
      this.formChange(vehicleClass);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
